import firebase from "firebase";

const firebaseConfig = {
    apiKey: "AIzaSyCjKWEftH8aH2IWOuutrUwpWOqh6WmciLc",
    authDomain: "fir-3c592.firebaseapp.com",
    projectId: "fir-3c592",
    storageBucket: "fir-3c592.appspot.com",
    messagingSenderId: "699201593470",
    appId: "1:699201593470:web:813b59ebeb76459701782f"
  };

const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore();
const auth = firebase.auth();

export { db, auth };